import { useMsal } from "@azure/msal-react";
import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import {
	getLoggedInUserUsingAccessToken
} from "../API/User/User";
import Loader from "../Components/Shared/Loader/loader";
import { GlobalContext } from "./GlobalContext";
import { useTranslation } from "react-i18next";
import { getUserItsOrganizationAndSubscription } from "../API/Organization/organization";
import { getProject } from "../API/Project/project";
export const WorkspaceProjectRouteRender = (props) => {
	const { dispatch } = useContext(GlobalContext);
	const context = useMsal();

	const { organizationId, projectId } = useParams();

	const [loading, setLoading] = useState(true);
	const [hasAccess, setHasAccess] = useState(false);
	const [accessError, setAccessError] = useState("");
	const [loggedInUser, setLoggedInUser] = useState({}); // [todo: remove this line]

	const [organization, setOrganization] = useState({});
	const [project, setProject] = useState({});

	const { i18n, ready: tReady } = useTranslation();

	// useEffect hook to fetch logged-in user using access token
	useEffect(() => {
		const { inProgress } = context;
		const accessToken = localStorage.getItem("accessToken");

		// If access token is not present, redirect to login page
		if (!accessToken) {
			setLoading(false);
			setHasAccess(false);
			setAccessError("Sorry, Please login to continue.");
			return;
		}

		if (inProgress !== "none") return; // Avoid duplicate code execution on page load

		// Fetch logged-in user using access token
		async function getUser() {
			const loggedInUser = await getLoggedInUserUsingAccessToken();
			setLoggedInUser(loggedInUser);
		}
		getUser();
	}, [context]);

	useEffect(() => {
		async function validateAccess() {
			if (loggedInUser && loggedInUser.emails && loggedInUser.emails.length > 0) {
				setLoading(true);
				const [{ organization, user, subscription }, project] = await Promise.all([
					getUserItsOrganizationAndSubscription(loggedInUser.emails[0], organizationId),
					getProject(projectId)
				]);
				if (organization) {
					if (!project) {
						setHasAccess(false);
						setAccessError("Sorry. This Project does not exist. Please contact the Admin(s).");
						setLoading(false);
						return;
					}
					if (project && !project.isActive) {
						setHasAccess(false);
						setAccessError("Sorry. This Project has been deactivated. Please contact the Admin(s).");
						setLoading(false);
						return;
					}
					setHasAccess(true);
					setAccessError("");
					setOrganization(organization || {});
					setProject(project || {});
					dispatch({ type: "SET_SUBSCRIPTION", payload: subscription });
					dispatch({ type: "SET_ORGANIZATION", payload: organization })
					dispatch({ type: "SET_USER", payload: user })
				} else {
					setHasAccess(false);
					setAccessError("Sorry. You have not been granted access to this Organization. Please contact the Admin(s).");
				}
				setLoading(false);
			}
		}
		validateAccess();
	}, [loggedInUser, organizationId]);

	useEffect(() => {
		if (tReady) {
			i18n.changeLanguage(organization.platformLanguage || "en");
		}
	}, [tReady, organization])

	const handleProjectUpdate = async (updatedProject) => {
		setProject(updatedProject);
	}

	if (loading) return <Loader />;

	if (!hasAccess) {
		return (
			<div className="container align-items-center" style={{ height: "100vh" }}>
				<div className="row justify-content-center">
					<div className="text-center">
						<img
							width={200}
							alt="Progress-Loader"
							src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/Error.png`}
						/>
						<div className="font-size-2 mx-5 px-5">{accessError}</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<React.Fragment>
			{React.Children.map(props.children, (child) => {
				if (React.isValidElement(child)) {
					return React.cloneElement(child, {
						project: { ...project },
						instanceId: projectId,
						updateProjectData: handleProjectUpdate
					});
				}
			})}
		</React.Fragment>
	)
}
